import { type JSX } from 'react';

import { Checkbox } from '@/ui';

interface CheckboxFieldProps {
  label: string | JSX.Element;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  error?: string;
  disabled?: boolean;
  description?: string;
}

const CheckboxField = ({
  label,
  value,
  onChange,
  error,
  disabled,
  description
}: CheckboxFieldProps) => (
  <div className="flex flex-col gap-1">
    <Checkbox
      label={label}
      checked={!!value}
      onChange={onChange}
      disabled={disabled}
      helpText={description}
    />
    {error && <p className="text-sm text-red-500 dark:text-red-400">{error}</p>}
  </div>
);

export default CheckboxField;
